import { cva } from '@/styled-system/css';

export const toggleCardRootRecipe = cva({
  base: {
    position: 'relative',
    display: 'block',
    padding: 'ToggleCard.Root.padding',
    borderRadius: 'ToggleCard.Root',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 0.2s ease-in, background-color 0.2s ease-in',
    },

    _focusVisible: {
      boxShadow: 'focus',
    },

    _after: {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      pointerEvents: 'none',
      transition: {
        _motionReduce: 'none',
        _motionSafe: 'border-color 200ms ease',
      },
    },
  },
  variants: {
    selected: {
      true: {
        _after: {
          borderWidth: 'ToggleCard.Root.selected',
          borderStyle: 'solid',
          borderColor: 'ToggleCard.Root.neutral.border.selected.default',
        },
        _notDisabled: {
          _hover: {
            _after: {
              borderColor: 'ToggleCard.Root.neutral.border.selected.hover',
            },
          },
          _active: {
            _after: {
              borderColor: 'ToggleCard.Root.neutral.border.selected.pressed',
            },
          },
        },
      },
      false: {},
    },

    outlined: {
      true: {},
      false: {},
    },

    disabled: {
      true: {
        boxShadow: 'none',
        cursor: 'default',
        opacity: 'disabled',
      },
      false: {
        cursor: 'pointer',
      },
    },

    elevated: {
      true: {},
      false: {},
    },

    tone: {
      neutral: {},
      soft: {},
    },
  },
  compoundVariants: [
    {
      selected: false,
      outlined: true,
      css: {
        _after: {
          borderWidth: 'ToggleCard.Root.default',
          borderStyle: 'solid',
          borderColor: 'ToggleCard.Root.neutral.border.default',
        },
        _notDisabled: {
          _hover: {
            _after: {
              borderColor: 'ToggleCard.Root.neutral.border.hover',
            },
          },
          _active: {
            _after: {
              borderColor: 'ToggleCard.Root.neutral.border.pressed',
            },
          },
        },
      },
    },
    {
      elevated: true,
      selected: false,
      disabled: false,
      css: {
        boxShadow: {
          base: 'ToggleCard.Root.default',
          _hover: 'ToggleCard.Root.hover',
          _active: 'ToggleCard.Root.pressed',
        },
      },
    },
    {
      elevated: false,
      tone: 'neutral',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.neutral.bg.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.neutral.bg.hover',
            _active: 'ToggleCard.Root.neutral.bg.pressed',
          },
        },
      },
    },
    {
      elevated: false,
      tone: 'soft',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.soft.bg.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.soft.bg.hover',
            _active: 'ToggleCard.Root.soft.bg.pressed',
          },
        },
      },
    },
    {
      elevated: true,
      tone: 'neutral',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.neutral.elevated.bg.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.neutral.elevated.bg.hover',
            _active: 'ToggleCard.Root.neutral.elevated.bg.pressed',
          },
        },
      },
    },
    {
      elevated: true,
      tone: 'soft',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.soft.elevated.bg.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.soft.elevated.bg.hover',
            _active: 'ToggleCard.Root.soft.elevated.bg.pressed',
          },
        },
      },
    },
    {
      selected: true,
      tone: 'neutral',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.neutral.bg.selected.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.neutral.bg.selected.hover',
            _active: 'ToggleCard.Root.neutral.bg.selected.pressed',
          },
        },
      },
    },
    {
      selected: true,
      tone: 'soft',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.soft.bg.selected.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.soft.bg.selected.hover',
            _active: 'ToggleCard.Root.soft.bg.selected.pressed',
          },
        },
      },
    },
    {
      elevated: true,
      selected: true,
      disabled: false,
      tone: ['neutral', 'soft'],
      css: {
        boxShadow: {
          _hover: 'ToggleCard.Root.hover',
          _active: 'none',
        },
      },
    },
    {
      elevated: true,
      selected: true,
      tone: 'neutral',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.neutral.elevated.bg.selected.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.neutral.elevated.bg.selected.hover',
            _active: 'ToggleCard.Root.neutral.elevated.bg.selected.pressed',
          },
        },
      },
    },
    {
      elevated: true,
      selected: true,
      tone: 'soft',
      css: {
        backgroundColor: {
          base: 'ToggleCard.Root.soft.elevated.bg.selected.default',
          _notDisabled: {
            _hover: 'ToggleCard.Root.soft.elevated.bg.selected.hover',
            _active: 'ToggleCard.Root.soft.elevated.bg.selected.pressed',
          },
        },
      },
    },
  ],
});
